import {
  GET_DASHBOARD_DETAILS,
  GET_DASHBOARD_DETAILS_SUCCESS,
  GET_DASHBOARD_DETAILS_FAILURE,
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAILURE,
  GET_WHATS_NEW,
  GET_WHATS_NEW_SUCCESS,
  GET_WHATS_NEW_FAILURE,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
  GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
} from "../action/types";
const INIT_STATE = {
  loading: false,
  lists: null,
  banners: null,
  whatsNew: null,
  interviewMonthlyStatsData: null,
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DASHBOARD_DETAILS:
      return { ...state, loading: true };
    case GET_DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        lists: action.payload,
      };
    case GET_DASHBOARD_DETAILS_FAILURE:
      return { ...state, loading: false };

    case GET_BANNERS:
      return { ...state, loading: true };
    case GET_BANNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        banners: action.payload,
      };
    case GET_BANNERS_FAILURE:
      return { ...state, loading: false };
    case GET_WHATS_NEW:
      return { ...state, loading: true };
    case GET_WHATS_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        whatsNew: action.payload,
      };
    case GET_WHATS_NEW_FAILURE:
      return { ...state, loading: false, whatsNew: null };
    case GET_INCBOT_INTERVIEW_MONTHLY_STATS:
      return { ...state, loading1: true, interviewMonthlyStatsData: null };
    case GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS:
      return {
        ...state,
        loading1: false,
        interviewMonthlyStatsData: action.payload,
      };
    case GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE:
      return { ...state, loading1: false, interviewMonthlyStatsData: null };

    default:
      return state;
  }
};
